export enum EvalueringType {
    Uddannelsessted = 1,
    Kompetence = 2
}
